<template>
  <div class="footer-container">
    
     <footer>     
        <div class="grain-effect"></div>  
          <div class="row m-0 footer-bar" style="display:flex; align-items: center;">      
            <div class="col-auto footer-left">
              <img class="pl-3 pr-4" :src="require('@/assets/icons/uptc_logo.svg')" alt="UPCTLogo" style="height: 30px;"/>
              <img  class="pr-4" :src="require('@/assets/icons/logo_cmn.svg')" alt="Campus Mare Nostrum Logo" style="height: 30px;"/>
              <img :src="require('@/assets/icons/um_logo.svg')" alt="UM Logo" style="height: 30px;"/>
            </div>
              <!-- <div class="col-xl-3 col-lg-1 ">
              </div> -->
              <div class="col-auto float-right text-right ml-auto footer-right ">
                <img :src="require('@/assets/icons/ctn_logo.svg')" class="mr-4" alt="CTN Logo" style="height: 30px;"/>
              </div>
          </div>
      </footer>
 </div>
</template>

<script>
export default {
  name: 'oomurFooter',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer{
  position:fixed;
  bottom:0;
  width:100%;
}
.grain-effect {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  background-image: url('~@/assets/img/grain.png');
  z-index: 0;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue